export const bookingSessionKeys = {
  all: ['booking-session'] as const,
  detail: (sessionId: string) => ['booking-session', 'detail', sessionId] as const,
  insuranceEstimate: (sessionId: string) =>
    ['booking-session', 'insurance-estimate', sessionId] as const,
  price: (sessionId: string) => ['booking-session', 'price', sessionId] as const,
  summary: (sessionId: string) => ['booking-session', 'summary', sessionId] as const,
}
